export const OAUTH_FETCHING_ERROR_PREFIX = 'Failed to fetch oauth providers';
